import { Box, useMediaQuery, useTheme } from "@mui/material";
import SimpleReportToolbar from "features/reports/SimpleReport/components/SimpleReportToolbar";
import CoordinatorReport2DataProvider from "./CoordinatorReport2DataProvider";
import CoordinatorReport2Provider from "./CoordinatorReport2Provider";
import CoordinatorReport2Filter from "./components/CoordinatorReport2Filter";
import CoordinatorReport2Header from "./components/CoordinatorReport2Header";
import CoordinatorReport2PivotTable from "./components/CoordinatorReport2PivotTable";

export interface CoordinatorReport2Props {}

const CoordinatorReport2: React.FC<CoordinatorReport2Props> = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <CoordinatorReport2DataProvider>
      <CoordinatorReport2Header />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          "& .MuiPaper-root": {
            borderRadius: isMobile ? 0 : undefined,
          },
        }}
      >
        <CoordinatorReport2Provider>
          <CoordinatorReport2Filter />
          <SimpleReportToolbar />
          <CoordinatorReport2PivotTable />
        </CoordinatorReport2Provider>
      </Box>
    </CoordinatorReport2DataProvider>
  );
};

export default CoordinatorReport2;
